import { render } from "./ResourcesRow.vue?vue&type=template&id=0be0dfcf"
import script from "./ResourcesRow.vue?vue&type=script&lang=js"
export * from "./ResourcesRow.vue?vue&type=script&lang=js"

import "./ResourcesRow.vue?vue&type=style&index=0&id=0be0dfcf&lang=css"

import exportComponent from "C:\\Users\\Loïc\\Downloads\\smsyou\\avalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__